import { useEffect } from "react";
import { TaskType, TaskTypeEnum } from "src/api/types";
import { useSentryLogger } from "src/hooks/useSentryLogger";
import { supabaseClient } from "src/supabase/supabaseClient";

export function usePrescriptionPrescribedSubscription(
  providerId: number | null,
  taskType: TaskTypeEnum,
  onSuccess: () => Promise<void>,
) {
  const errorLog = useSentryLogger("error");
  const log = useSentryLogger();

  useEffect(() => {
    let channel: ReturnType<typeof supabaseClient.channel> | undefined;

    if (
      taskType === TaskType.PriorAuthApproved ||
      taskType === TaskType.EPrescriptionRequest
    ) {
      if (providerId == null) return;

      (async () => {
        try {
          await supabaseClient.realtime.setAuth();

          channel = supabaseClient
            .channel(`prescriptions:provider:${providerId}`, {
              config: { private: true },
            })
            .on("broadcast", { event: "UPDATE" }, () => {
              onSuccess();
            })
            .subscribe((status, error) => {
              if (error != null) {
                errorLog("Prescription subscribe error:", error);
              } else {
                log("Prescription subscribe status:", status);
              }
            });
        } catch (err) {
          errorLog("Error with prescription realtime subscription", err);
        }
      })();
    }
    return () => {
      if (channel) {
        supabaseClient.removeChannel(channel);
      }
    };
  }, [errorLog, log, onSuccess, providerId, taskType]);
}
